import React from "react";
import * as Icon from "react-feather";

import WComponent from "../common/WComponent";
import PlaybookScriptService from "../../services/PlaybookScriptService";

import "./build-page.css";
import "./playbook-build-scripts.css";

class PlaybookBuildScriptsCard extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			isNotOnItsStepShown: false,
		};
	}

	renderScript = script => {
		const { viewer, isOpen, onOpenScript } = this.props;
		const card = PlaybookScriptService.describeScriptCard({ script, viewer, isConversationOpen: isOpen });
		const isLive = card.isOnItsGap && viewer.areScriptsOn;
		const statusText = script.isApproved ? card.approvedText : `${card.testText} ${card.reviewText}`;
		const isActionsLineShown = isLive && !script.isApproved && Boolean(card.actionsText);
		const isBlockedFromApproval = isLive && isOpen && !script.isApproved;
		const blockers = isBlockedFromApproval ? card.approveBlockers : [];

		return (
			<li key={script.pinId} className="playbook-build-scripts__script">
				<div className="playbook-build-scripts__head">
					<span className="playbook-build-scripts__title">{card.title}</span>
					<button type="button" className="tk-button tk-button--secondary tk-button--compact" onClick={() => onOpenScript({ pinId: script.pinId })}>
						Open
					</button>
				</div>
				{card.plainDescription && <span className="playbook-build-scripts__description">{card.plainDescription}</span>}
				{isLive && (
					<span className={script.isApproved ? "playbook-build-scripts__status playbook-build-scripts__status--approved" : "playbook-build-scripts__status"}>
						{script.isApproved && <Icon.CheckCircle size={13} className="playbook-build-scripts__status-icon" />}
						{statusText}
					</span>
				)}
				{isActionsLineShown && <span className="playbook-build-scripts__status">{card.actionsText}</span>}
				{blockers.length > 0 && (
					<ul className="playbook-build-scripts__blockers">
						{blockers.map(blocker => (
							<li key={blocker} className="playbook-build-scripts__blocker">
								{blocker}
							</li>
						))}
					</ul>
				)}
				{card.closedText && <span className="playbook-build-scripts__status">{card.closedText}</span>}
			</li>
		);
	};

	render() {
		const { scripts, viewer } = this.props;
		const { isNotOnItsStepShown } = this.state;
		if (!scripts || scripts.length === 0) return null;
		const scriptsOnTheirStep = scripts.filter(script => script.isOnItsGap);
		const scriptsNotOnTheirStep = scripts.filter(script => !script.isOnItsGap);
		const hasScriptsNotOnTheirStep = scriptsNotOnTheirStep.length > 0;

		return (
			<section className="build-card tk-card playbook-build-scripts">
				<div className="build-card__head">
					<span className="build-card__title">Scripts</span>
					<span className="tk-muted">{scriptsOnTheirStep.length}</span>
				</div>
				{!viewer.areScriptsOn && <div className="tk-notice playbook-build-scripts__off">{viewer.whyNotApprove}</div>}
				{scriptsOnTheirStep.length > 0 && <ul className="playbook-build-scripts__list">{scriptsOnTheirStep.map(this.renderScript)}</ul>}
				{hasScriptsNotOnTheirStep && (
					<div className="playbook-build-scripts__folded">
						<button
							type="button"
							className="tk-text-action tk-text-action--muted"
							onClick={() => this.update({ isNotOnItsStepShown: !isNotOnItsStepShown })}
							aria-expanded={isNotOnItsStepShown}
						>
							{isNotOnItsStepShown ? <Icon.ChevronUp size={14} /> : <Icon.ChevronDown size={14} />}
							Not on its step ({scriptsNotOnTheirStep.length})
						</button>
						{isNotOnItsStepShown && <ul className="playbook-build-scripts__list">{scriptsNotOnTheirStep.map(this.renderScript)}</ul>}
					</div>
				)}
			</section>
		);
	}
}

export default PlaybookBuildScriptsCard;
